import { apiPaths, mamutilsApi } from '@services';
import {
    FavoritesResponse,
    GetFavoritesArgs,
    ToggleFavoriteArgs,
} from '../types';

const enhancedApi = mamutilsApi.enhanceEndpoints({
    addTagTypes: ['Favorites'],
});

const extendedApi = enhancedApi.injectEndpoints({
    endpoints: (builder) => ({
        getFavorites: builder.query<string[], GetFavoritesArgs>({
            query: (params) => ({
                url: apiPaths.favorites.base(),
                method: 'GET',
                params,
            }),
            providesTags: () => ['Favorites'],
            transformResponse: (response: FavoritesResponse) =>
                response.favorites,
        }),

        toggleFavorite: builder.mutation<void, ToggleFavoriteArgs>({
            query: ({ isFavorite, ...body }) => ({
                url: apiPaths.favorites.base(),
                method: isFavorite ? 'POST' : 'DELETE',
                body,
            }),

            onQueryStarted: async (
                { isFavorite, collectionId, ...context },
                { dispatch, queryFulfilled },
            ) => {
                const patchResult = dispatch(
                    extendedApi.util.updateQueryData(
                        'getFavorites',
                        context,
                        (draft) => {
                            if (isFavorite) {
                                if (!draft.includes(collectionId)) {
                                    draft.push(collectionId);
                                }
                            } else {
                                const index = draft.indexOf(collectionId);
                                if (index !== -1) {
                                    draft.splice(index, 1);
                                }
                            }
                        },
                    ),
                );

                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            },
        }),
    }),
});

export const { useGetFavoritesQuery, useToggleFavoriteMutation } = extendedApi;

export default extendedApi.endpoints;
